<template>
  <div class="scores-container">
    <score v-for="score in values"
                   :key="score.label"
                   :label="score.label"
                   :tooltip="score.tooltip"
                   :value="score.value" />
  </div>
</template>

<script>
  import Score from './Score'

  export default {
    components: {
      Score,
    },

    props: {
      values: Array,
    },
  }
</script>

<style lang="scss" scoped>
  .scores-container {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;
    height: 100%;
  }

  .score {
    display: flex;
    flex-basis: 50%;
    justify-content: center;
    flex-direction: column;
    border-right: 1px solid #e0e0e0;
    border-top: 1px solid #e0e0e0;

    &:first-child,
    &:nth-child(2) {
      border-top: 0;
    }

    &:nth-of-type(2n) {
      border-right-width: 0;
    }
  }
</style>
